import PlanejamentoAcaoCardsAcoes from '../../../produto/spa/planejamento-acao/list/PlanejamentoAcaoCardsAcoes';

export default PlanejamentoAcaoCardsAcoes;
